/**
 * Sequence Recall: per-round scoring helpers.
 *
 * The game is strictly binary: the player must tap the shown cells in the
 * exact same order. Any position mismatch — or a user path shorter than the
 * target sequence — invalidates the whole round.
 */

export interface SequenceRecallRoundMetrics {
  correct: boolean;
  accuracy: 0 | 1;
  errorCount: 0 | 1;
  /** 1-based index of the first wrong tap (0 if no errors or no input). */
  firstErrorIndex: number;
}

export function computeSequenceRecallRoundMetrics(
  sequence: number[],
  userInput: number[],
): SequenceRecallRoundMetrics {
  if (sequence.length === 0) {
    return {
      correct: true,
      accuracy: 1,
      errorCount: 0,
      firstErrorIndex: 0,
    };
  }

  let firstErrorIndex = 0;
  if (userInput.length < sequence.length) {
    firstErrorIndex = userInput.length + 1;
  } else {
    for (let i = 0; i < sequence.length; i++) {
      if (userInput[i] !== sequence[i]) {
        firstErrorIndex = i + 1;
        break;
      }
    }
  }
  const correct = firstErrorIndex === 0 && userInput.length === sequence.length;
  return {
    correct,
    accuracy: correct ? 1 : 0,
    errorCount: correct ? 0 : 1,
    firstErrorIndex,
  };
}
